import React from 'react';

// components
import Domains from 'pages/MerchantPages/Settings/Auth/Oauth/containers/Domains';
import BaseModal, { ModalActions } from 'components/Modals/BaseModal';

// types
import { ModalNames } from 'ducks/merchantDucks/modal/types';

export interface Domain {
  id: number;
  domain: string;
}

interface Props {
  domains: Array<Domain>;
}

const EnableSSO = ({ domains, ...rest }: Props) => (
  <BaseModal
    modalName={ModalNames.EnableSSO}
    title="Enable SSO"
    type="sso"
    {...rest}
    render={({ closeModal }: ModalActions) => <Domains handleCloseModal={closeModal} domains={domains} />}
  />
);

export default EnableSSO;
